import * as THREE from 'three';

import { Cylinder, Grid, OrbitControls, PerspectiveCamera, View } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as React from 'react';

type MyDebugProps = {
  children?: React.ReactNode;
};

function HelperSetup() {
  const { scene, camera } = useThree();
  React.useEffect(() => {
    const { id, children } = scene;
    console.log(`${id} camera[${camera.id}]: ${camera.name || '(no name)'}`);
    for (const child of children) {
      const { id, name } = child;
      console.log(`  - obj[${id}]: ${name}`);
      if (child instanceof THREE.Camera) {
        const { type, visible } = child;
        console.log(`    - ${type} ${visible}`);
        if (name == 'main') {
          scene.add(new THREE.CameraHelper(child));
        }
      }
    }
  }, []);
  return <></>;
}

function MyDebug(props: MyDebugProps) {
  const { children } = props;
  const ref = React.useRef<HTMLDivElement>(null!);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <View className="view-1" style={{ flexGrow: 1 }}>
          <color attach="background" args={['#000000']} />
          {children}
          <HelperSetup />
          <OrbitControls />
        </View>
        <View className="view-1" style={{ flexGrow: 1 }}>
          <color attach="background" args={['#000000']} />
          {children}
          <HelperSetup />
          <PerspectiveCamera name="secondary" makeDefault position={[5, 5, 8]} fov={35} />
          <OrbitControls />
        </View>
      </div>
      <Canvas eventSource={ref} className="canvas">
        <View.Port />
      </Canvas>
    </div>
  );
}

export type Props = {};

const fov = 53;
const aspect = 2; // the canvas default
const near = 0.1;
const far = 5;
const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
camera.name = 'main';
camera.position.set(0, 0, 3);
camera.setViewOffset(100, 100, 20, 0, 100, 100);

function SetupCamera() {
  const { scene, set } = useThree();
  React.useLayoutEffect(() => {
    scene.add(camera);
    set({ camera });
  }, []);
  return <></>;
}

function App(props: Props) {
  const {} = props;

  return (
    <MyDebug>
      <SetupCamera />
      <mesh>
        <boxGeometry args={[2, 2, 1]} />
        <meshBasicMaterial wireframe />
      </mesh>
      <Cylinder>
        <meshBasicMaterial wireframe />
      </Cylinder>
      <Grid args={[10, 10]} cellColor="white" />
    </MyDebug>
  );
}

export default React.memo(App);
